import Modal from "react-bootstrap/Modal";
import ShiftShiftDetailsElement from "../components/ShiftShiftDetailsElement";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ShiftAvailabilityMatchesElement from "../components/ShiftAvailabilityMatchesElement";
import ShiftAssociatedBookingElement from "../components/ShiftAssociatedBookingElement";
import { ButtonModalClose } from "../components/ButtonModalClose";
import { ButtonModalLink } from "../components/ButtonModalLink";
import ShiftTimesheetElement from "../components/ShiftTimesheetElement";

export const ShiftTableDetailModal = ({ visible, close, shift }) => {
  const selectRightDisplay = () => {
    if (shift === null || shift === undefined) return;

    if (
      shift?.timesheet?.id !== null &&
      shift?.timesheet?.id !== undefined &&
      shift?.status === "COMPLETED"
    ) {
      return (
        <Col>
          <ShiftTimesheetElement shift={shift} />
        </Col>
      );
    }
    if (shift?.availabilityMatches && shift?.status === "OPEN") {
      return (
        <Col>
          <ShiftAvailabilityMatchesElement shift={shift} />
        </Col>
      );
    }
    if (shift?.user?.id !== null) {
      return (
        <Col>
          <ShiftAssociatedBookingElement shift={shift} />
        </Col>
      );
    }
  };

  const selectDisplay = () => {
    return (
      <Row>
        <Col>
          <ShiftShiftDetailsElement shift={shift} />
        </Col>
        {selectRightDisplay()}
      </Row>
    );
  };
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize text-axis-offblack"}
        >
          Request ID: {shift?.notificationId}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{selectDisplay()}</Modal.Body>
      <Modal.Footer>
        <Row className={"w-100"}>
          <Col>
            <ButtonModalClose
              className={"w-100"}
              buttonText={"Close"}
              close={close}
            />
          </Col>
          <Col>
            <ButtonModalLink
              name={"Open"}
              link={
                shift?.table === "shifts"
                  ? { pathname: `/shifts/view/${shift?.id}` }
                  : { pathname: `/archiveShifts/view/${shift?.id}` }
              }
              className={"w-100"}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};
